export default {
  styleOverrides: {

  }
}
